
































































































































































import { Component, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererFunc,
  ICellRendererParams,
  IServerSideDatasource,
} from 'ag-grid-community';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import Contrato from '@/pantallas/SucursalVirtual/Contratos/controllers/ContratoController';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import ContratoModalAgregar from '@/pantallas/SucursalVirtual/Contratos/ContratoModalAgregar.vue';
import ContratoModalEditar from '@/pantallas/SucursalVirtual/Contratos/ContratoModalEditar.vue';
import type {
  FiltrosGrilla,
  Ejecutivo,
  Cliente,
  EstadoFirma,
  TipoFecha,
  ContratoGrilla,
} from '@/pantallas/SucursalVirtual/Contratos/types';
import { actionsEvent } from '@/setup';
import ModalConfirmacionReporteCreado from '@/components/ModalConfirmacionReporteCreado.vue';
import Confirmation from '@/components/Confirmation.vue';
import { contratosFetch } from '@/pantallas/SucursalVirtual/Contratos/contratosFetch';
import { NONAME } from 'dns';

@Component({
  components: {
    MantenedorGridSinCodigo,
    FormFieldsContainer,
    DatePicker,
    ContratoModalAgregar,
    ContratoModalEditar,
    ModalConfirmacionReporteCreado,
    'app-confirmacion': Confirmation,
  },
})

class ContratosBase extends ComponenteBase {
  readonly funcionalidad = Funcionalidades.Contrato;
  readonly accionesTotales: PermisoAccion[] = [
    {
      accionCodigo: 3,
      visible: false,
    },
    {
      accionCodigo: 4,
      visible: false,
    },
    {
      accionCodigo: 5,
      visible: false,
    },
  ];

  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridApi: GridApi = null;
  serverSide: IServerSideDatasource = null;
  usuarioID = String(JSON.parse(localStorage.getItem('user')).id) || '';
  clienteDefecto = localStorage.getItem('clienteDefecto') || '';
  email = String(JSON.parse(localStorage.getItem('user')).email) || '';
  activarBuscadorAutomatico = false;
  abrirModalAgregar = false;
  abrirModalEditar = false;
  esModalVerDetalle = false;
  tipoFechaHastaLabel = '';
  tipoFechaDesdeLabel = '';
  abrirModalReportes = false;
  textoReportes = '';
  mostrarModalConfirmacion = false;
  total_registros: any = '';

  filtrosEstadoInicial: FiltrosGrilla = {
    ejecutivoId: '',
    usuarioId: this.usuarioID,
    email: '',
    rut: '',
    cliente: '',
    estadoFirmaId: '',
    fechaDesde: null,
    fechaHasta: null,
    inicioGrilla: '0',
    finGrilla: '25',
    busquedaRapida: '',
    tipoFecha: '1',
  };

  ejecutivo: Ejecutivo = {
    email: '',
    nombre_completo: '',
    id_ejecutivo: '',
    area: '',
  };

  filtrosGrilla: FiltrosGrilla = {
    ...this.filtrosEstadoInicial,
  };
  ejecutivos: Ejecutivo[] = [];
  clientes: Cliente[] = [];
  ruts: Cliente[] = [];
  estadosFirma: EstadoFirma[] = [];
  tiposFechas: TipoFecha[] = [];
  contratoId: ContratoGrilla['id_contrato'] = '';

  acciones() {
    actionsEvent.onEditar(this.handleEditar);
    actionsEvent.onEliminar(this.handleEliminar);
    actionsEvent.onVerDetalle(this.handleVerDetalle);
  }

  constructor() {
    super();
    // Remover acciones
    actionsEvent.removeListeners();
    // Llamado a las acciones
    this.acciones();

    this.gridOptions = {
      columnDefs: this.columnasGrilla(),
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      onGridReady: this.handleGrillaLista,

      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
    };
  }

  createLink(data: any){
    if (data === undefined || data.data===undefined){
      return '';
    }
    const estaActivo = data.data.archivo_desactivado !== 't';
    return data.data.url_pdf && estaActivo
      ? `<a href="${data.data.url_pdf}" target="_blank" style="position: absolute; margin-top: 0%; margin-left: 3%; cursor: pointer;">
          <i class="material-icons" id="1356" style="cursor: pointer; color: rgb(39, 72, 142); font-size: 25px; padding-top: 5px;">download</i>
      </a>`
      : '';
  }


  private columnasGrilla(): ColDef[] {
    const columnas = [
      { headerName: 'Nro Contrato', field: 'id_contrato', cellStyle: { textAlign: 'left' }, resizable: true, width: 140, minWidth: 140, },
      { headerName: 'Rut Cliente', field: 'rut', cellStyle: { textAlign: 'left' }, resizable: true, width: 140, minWidth: 140,  },
      { headerName: 'Razón Social', field: 'cliente', cellStyle: { textAlign: 'left' }, resizable: true, minWidth: 100,  },
      { headerName: 'Ejecutivo', field: 'nombre_completo', cellStyle: { textAlign: 'left' }, resizable: true, minWidth: 100, },
      { headerName: 'Área', field: 'area', cellStyle: { textAlign: 'left' }, resizable: true, minWidth: 100, },
      { headerName: 'Fecha de Registro', field: 'fecha_registro', cellStyle: { textAlign: 'left' }, resizable: true, width: 200, minWidth: 140,  },
      { headerName: 'Fecha de Vencimiento', field: 'fecha_vencimiento', cellStyle: { textAlign: 'left' }, resizable: true, width: 200, minWidth: 100,  },
      { headerName: 'Estado', field: 'estado_firma', cellStyle: { textAlign: 'left' }, resizable: true, width: 140, minWidth: 100, },
      { headerName: 'Ver Archivo', field: 'url_pdf', cellStyle: { textAlign: 'left' }, resizable: true, minWidth: 100, cellRenderer: this.createLink, hide: true },
    ];
/*
    const columnas = [
      { headerName: 'Nro Contrato', field: 'id_contrato' },
      { headerName: 'Rut Cliente', field: 'rut' },
      { headerName: 'Razón Social', field: 'cliente' },
      { headerName: 'Ejecutivo', field: 'nombre_completo' },
      { headerName: 'Área', field: 'area' },
      { headerName: 'Fecha de Creación', field: 'fecha_creacion' },
      { headerName: 'Fecha de Vencimiento', field: 'fecha_vencimiento' },
      { headerName: 'Estado', field: 'estado_firma' },
      { headerName: 'Ver Archivo', field: 'url_pdf' },
    ];

    const columnasGrilla: ColDef[] = columnas.map(({ headerName, field }) => {

      let cellRenderer: ICellRendererFunc = null;

      if (field === 'url_pdf') {
        cellRenderer = ({ data }: ICellRendererParams) => {
          const estaActivo = data.archivo_desactivado !== 't';
          return data.url_pdf && estaActivo
            ? `<a href="${data.url_pdf}" target="_blank" style="position: absolute; margin-top: 0%; margin-left: 3%; cursor: pointer;">
                <i class="material-icons" id="1356" style="cursor: pointer; color: rgb(39, 72, 142); font-size: 25px; padding-top: 5px;">download</i>
            </a>`
            : '';
        };
      }
      return {
        headerName,
          field,
          cellStyle: { textAlign: 'left' },
        resizable: true,
        minWidth: 100,
        cellRenderer,
      }
    });*/

    return columnas;
  }

  @Watch('filtrosGrilla.fechaDesde')
  validarFechaDesde() {
    if (this.filtrosGrilla.fechaHasta && this.filtrosGrilla.fechaDesde > this.filtrosGrilla.fechaHasta) {
      this.filtrosGrilla.fechaHasta = this.filtrosGrilla.fechaDesde;
    }
    //this.handleChangeFiltros();
  }

  @Watch('filtrosGrilla.fechaHasta')
  validarFechaHasta() {
    if (this.filtrosGrilla.fechaDesde && this.filtrosGrilla.fechaHasta < this.filtrosGrilla.fechaDesde) {
      this.filtrosGrilla.fechaDesde = this.filtrosGrilla.fechaHasta;
    }
    //this.handleChangeFiltros();
  }


  async handleGrillaLista(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    const self = this;
    await this.obtenerFiltrosContratos();
    this.serverSide = {
      async getRows(params) {
        self.loadingService.showLoading();
        const { startRow: inicioGrilla, endRow: finGrilla } = params.request;
        let body: FiltrosGrilla = {
          ...self.filtrosGrilla,
          inicioGrilla: inicioGrilla.toString(),
          finGrilla: finGrilla.toString(),
        };
        body['total_registros'] = self.total_registros;
        try {
          //const { contratos, totalRegistros } = await Contrato.obtenerContratosPorFiltros(body);
          //params.successCallback(contratos, totalRegistros);
          await contratosFetch({
            endpoint: 'obtener_contratos_por_filtros',
            body,
          }).then((resp: any) => {
            if (resp.data.CODIGO_RESPUESTA=='1'){
              console.log(resp.data);
              self.total_registros = resp.data.TOTAL_REGISTROS as number;
              params.successCallback(resp.data.CONTRATOS, self.total_registros);
            }else{
              self.$snotify.error(resp.data.MENSAJE_RESPUESTA,{timeout: 3500,});
              params.successCallback([{}], 0);
              self.total_registros = '';
            }
          }).catch((err: Error) => {
            console.error(err.message);
            self.$snotify.error(
              'Ocurrió un error inesperado, por favor reintente un poco más tarde.',
              {
                timeout: 3500,
              }
            );
            throw err;
          })
          .finally(() => self.loadingService.hideLoading());
        } catch (e) {
          params.successCallback([{}], 0);
          self.gridApi.showNoRowsOverlay();
          self.$snotify.error((e as Error).message);
        } finally {
          self.loadingService.hideLoading();
        }
      },
    };
    this.recargarGrilla({});
  }

  async obtenerFiltrosContratos() {
    this.loadingService.showLoading();
    try {
      const {
        ejecutivos,
        clientes,
        estadosFirma,
        tiposFechas,
      } = await Contrato.obtenerFiltrosContratos();

      this.ejecutivos = ejecutivos;
      this.clientes = clientes;
      this.estadosFirma = estadosFirma;
      this.tiposFechas = tiposFechas;
      const { tipo_fecha } = this.tiposFechas.find(({ id_tipo }) => id_tipo === this.filtrosGrilla.tipoFecha);
      this.tipoFechaDesdeLabel = `${tipo_fecha} Desde`;
      this.tipoFechaHastaLabel = `${tipo_fecha} Hasta`;
      this.ruts = clientes;
    } catch (error) {
      this.$snotify.error((error as Error).message);
    }
  }

  mostrarConfirmacion(aceptar: boolean) {
    aceptar && this.eliminar();
    this.mostrarModalConfirmacion = false;
  }

  handleChangeFiltros() {
    this.activarBuscadorAutomatico && this.recargarGrilla({});
  }

  handleChangeEjecutivo() {
    if (this.ejecutivo === undefined){
      this.filtrosGrilla.ejecutivoId = '';
      this.filtrosGrilla.email = ''

    }else{
      this.filtrosGrilla.ejecutivoId = this.ejecutivo.id_ejecutivo;
      this.filtrosGrilla.email = this.ejecutivo.email;
    }
    //this.handleChangeFiltros();
  }

  handleTipoFechaNombre() {
    if (!this.filtrosGrilla.tipoFecha) {
      this.filtrosGrilla.tipoFecha = '1';
    }
    const { tipo_fecha } = this.tiposFechas.find(({ id_tipo }) => id_tipo === this.filtrosGrilla.tipoFecha);
    this.tipoFechaDesdeLabel = `${tipo_fecha} Desde`;
    this.tipoFechaHastaLabel = `${tipo_fecha} Hasta`;
   // this.handleChangeFiltros();
  }

  handleInputFiltros() {
    const timeOutId = setTimeout(() => {
      this.recargarGrilla({});
      clearTimeout(timeOutId);
    }, 1500);
  }

  handleActivarBuscadorAutomatico() {
    this.activarBuscadorAutomatico = true;
    this.recargarGrilla({});
  }

  handleEditar({ data }: ICellRendererParams) {
    const { id_contrato }: ContratoGrilla = data;
    if (!id_contrato) return;
    this.contratoId = id_contrato;
    this.abrirModalEditar = true;
  }

  handleEliminar({ data }: ICellRendererParams) {
    const { id_contrato }: ContratoGrilla = data;
    if (!id_contrato) return;
    this.contratoId = id_contrato;
    this.mostrarModalConfirmacion = true;
  }


  async eliminar() {
    this.loadingService.showLoading();
    try {
      const { mensajeExito } = await Contrato.eliminarContrato(this.contratoId, this.usuarioID, this.clienteDefecto);
      this.$snotify.success(mensajeExito);
      this.recargarGrilla({});
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  handleVerDetalle({ data }: ICellRendererParams) {
    const { id_contrato }: ContratoGrilla = data;
    this.contratoId = id_contrato;
    this.abrirModalEditar = true;
    this.esModalVerDetalle = true;
  }
  async recargarGrilla({ limpiarFiltros = false }) {
    limpiarFiltros && this.limpiarFiltros();
    this.total_registros = '';
    const timeOutId = setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
      clearTimeout(timeOutId);
    }, 100);
  }

  async obtenerExcel() {
    this.loadingService.showLoading();
    const buscarEstadoFirma = this.estadosFirma.find(({ id_estado_firma }) => id_estado_firma === this.filtrosGrilla.estadoFirmaId);
    const estadoFirma = buscarEstadoFirma ? buscarEstadoFirma.estado_firma : '';
    const buscarNombreEjecutivo = this.ejecutivos.find(({ email }) => email === this.filtrosGrilla.email);
    const nombreEjecutivo = buscarNombreEjecutivo ? buscarNombreEjecutivo.nombre_completo : '';
    const body: FiltrosGrilla = {
      ...this.filtrosGrilla,
      estadoFirma,
      nombreEjecutivo,
    };

    try {
      const { mensajeExito } = await Contrato.obtenerExcelContratos(body, this.usuarioID, this.clienteDefecto);
      this.textoReportes = mensajeExito;
      this.abrirModalReportes = true;
    } catch (e) {
      this.$snotify.error((e as Error).message);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  limpiarFiltros() {
    this.activarBuscadorAutomatico = false;
    this.filtrosGrilla = {
      ...this.filtrosEstadoInicial,
    };
    this.total_registros = '';
  }

  crearNuevoContrato() {
    this.abrirModalAgregar = true;
  }

  handleCerrarModales(recargarGrilla = false) {
    this.abrirModalAgregar = false;
    this.abrirModalEditar = false;
    this.esModalVerDetalle = false;
    this.abrirModalReportes = false;
    this.textoReportes = '';
    recargarGrilla && this.recargarGrilla({});
  }
}

export default ContratosBase;
